module.exports = __webpack_public_path__ + "static/media/eimi-fukada-win.efb6f78a.jpg";